/** Matches App\Models\ClassroomLesson::CALL_TYPE_* */
export const CALL_TYPE_LANGUAGEON = "languageon";
export const CALL_TYPE_GOOGLE_MEET = "google_meet";
export const CALL_TYPE_OFFLINE = "offline";

export const CALL_TYPE_OPTIONS = [
    {
        value: CALL_TYPE_LANGUAGEON,
        label: "Languageon",
    },
    {
        value: CALL_TYPE_GOOGLE_MEET,
        label: "Google Meet",
    },
    {
        value: CALL_TYPE_OFFLINE,
        label: "Offline",
    },
];
